import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import practices from './modules/practices'
import systemInfo from './modules/systemInfo'

Vue.use(Vuex)

// TODO
export default new Vuex.Store({
    modules: {
        user,
        practices,
        systemInfo
    },
    strict: true
})
